import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

export const DAYS_OF_WEEK = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

export const DAYS_OF_WEEK_SHORT = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export const STUDY_BLOCKS = [
    { block: 1, start: '08:00', end: '09:30' },
    { block: 2, start: '09:45', end: '11:15' },
    { block: 3, start: '11:30', end: '13:00' },
    { block: 4, start: '14:00', end: '15:30' },
    { block: 5, start: '15:45', end: '17:15' },
    { block: 6, start: '17:30', end: '19:00' },
];

export function formatTime(time: string): string {
    return time;
}

export function getStudyBlockFromTime(time: string): number | null {
    for (const block of STUDY_BLOCKS) {
        if (time >= block.start && time <= block.end) {
            return block.block;
        }
    }
    return null;
}
